<div class="vertical body" [ngClass]="getClassList()">
  <app-board-icon [size]="50" [board]="board" [showTooltip]="false" [hideUserStatus]="false"></app-board-icon>
  <div class="text">{{ getBoardName(board) }}</div>
</div>
